import { render, staticRenderFns } from "./AdminUserDetailView.vue?vue&type=template&id=4b61a8e6&scoped=true"
import script from "./AdminUserDetailView.vue?vue&type=script&lang=js"
export * from "./AdminUserDetailView.vue?vue&type=script&lang=js"
import style0 from "./AdminUserDetailView.vue?vue&type=style&index=0&id=4b61a8e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b61a8e6",
  null
  
)

export default component.exports